exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.do-not-cancel-button{color:#3f3d3d;height:41px;box-sizing:content-box}[dir] .do-not-cancel-button{border:1px solid #3f3d3d;padding-top:15px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/do-not-cancel-button/do-not-cancel-button.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/do-not-cancel-button/do-not-cancel-button.component.scss
// module chunks = 0